export class artist {
  id: number;
  title: string;
}



// WEBPACK FOOTER //
// ./src/models/artist.model.ts